import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { COWTUXProgressBarComponent } from './progress-bar.component';
import { MatProgressSpinnerModule } from '@angular/material';

@NgModule({
    declarations: [
        COWTUXProgressBarComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule
    ],
    exports     : [
        COWTUXProgressBarComponent
    ]
})
export class FuseProgressBarModule
{
}
